<template>
  <div>
    <div class="row">
      <div class="form-group col-4 d-flex my-4">
        <input
          id="filtro"
          type="text"
          class="form-control"
          :placeholder="`${this.$t(
            'menu.settings.alertsNewsletters.placeholderSearch',
          )}`"
          v-model="filter"
          @keyup="handleFilter"
        />
        <button class="btn btn-outline-primary" @click="cleanFilter">
          {{ $t('menu.settings.alertsNewsletters.buttonClear') }}
        </button>
      </div>
    </div>

    <div>
      <b-table
        striped
        :items="branchItems"
        :fields="fields"
        :busy="loadingBranches"
        responsive
      >
        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner type="grow" class="align-middle"></b-spinner>
          </div>
        </template>
        <template v-slot:cell(bulletin)="row">
          <p :class="row.item.bulletin ? 'text-dark' : 'text-danger'">
            {{
              row.item.bulletin
                ? $t('menu.settings.alertsNewsletters.yesLabel')
                : $t('menu.settings.alertsNewsletters.noLabel')
            }}
          </p>
        </template>

        <template v-slot:cell(updatedAt)="row">
          <p>
            {{ row.item.updatedAt ? formatDate(row.item.updatedAt) : '-' }}
          </p>
        </template>

        <template v-slot:cell(options)="row">
          <button
            v-b-modal="`modal-branch-bulletin-edit-${row.item.branchId}`"
            class="btn btn-outline-primary"
          >
            <font-awesome-icon :icon="['fas', 'pen']" />
            <modal-branch-bulletin-edit
              :branchData="row.item"
              :page="page"
              :filter="filter"
            />
          </button>
        </template>
      </b-table>
      <div class="pagination-area-edit-rule mt-1">
        <paginate
          v-model="page"
          :pageCount="Math.ceil(total / this.limit)"
          :clickHandler="getBranches"
          :prevText="'‹'"
          :nextText="'›'"
          :activeClass="'active'"
          :containerClass="'pagination b-pagination'"
          :pageClass="'page-item'"
        ></paginate>
      </div>
    </div>
  </div>
</template>
<script>
import paginate from 'vuejs-paginate';
import { lightFormat } from 'date-fns';
import api from '../../../../../services/api';
import modalBranchBulletinEdit from './modal-branch-bulletin-edit';
import modalAlertRuleBranch from '../../../../molecules/modal-alert-rule-branch';
import EventBus from '../../../../../eventBus';

export default {
  props: ['mainRuleId'],

  components: {
    modalBranchBulletinEdit,
    modalAlertRuleBranch,
    paginate,
  },

  computed: {},

  data: () => ({
    total: 10,
    page: 1,
    limit: 10,
    loading: false,
    userAuth: null,
    filter: null,
    companyBranches: [],
    branchItems: [],
    loadingBranches: false,
    fields: [],
  }),

  methods: {
    async cleanFilter() {
      this.filter = null;
      await this.getBranches();
    },

    async handleFilter() {
      this.page = 1;
      await this.getBranches();
    },

    formatDate(myDate) {
      const day = lightFormat(new Date(myDate), 'dd/MM/yyyy');
      const time = lightFormat(new Date(myDate), 'HH:mm');
      return `${day} às ${time}`;
    },

    async getTotal() {
      this.loadingBranches = true;
      const response = await api.get(
        `branch-bulletin/${this.userAuth.companyId}/branches`,
        {
          headers: { 'x-access-token': this.userAuth.token },
        },
      );
      this.total = response.data.total;
    },

    async getBranches() {
      this.loadingBranches = true;
      const response = await api.get(
        `branch-bulletin/${this.userAuth.companyId}/branches`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            limit: this.limit,
            page: this.page,
            filter: this.filter,
          },
        },
      );

      this.companyBranches = response.data.companyBranches;
      this.branchItems = this.companyBranches;
      this.getTotal();

      this.loadingBranches = false;
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    await this.getBranches();

    this.fields = [
      {
        key: 'name',
        label: this.$t('menu.settings.alertsNewsletters.labels.branch'),
      },
      {
        key: 'bulletin',
        label: this.$t('menu.settings.alertsNewsletters.labels.haveAlert'),
        class: 'center-data',
        sortable: true,
      },
      {
        key: 'updatedAt',
        label: this.$t('menu.settings.alertsNewsletters.labels.ruleUpdateDate'),
        class: 'center-data',
        sortable: true,
      },
      {
        key: 'options',
        label: this.$t('menu.settings.alertsNewsletters.labels.options'),
        class: 'center-data, dflex',
      },
    ];
  },

  async mounted() {
    EventBus.$on('updateBranchBulletinList', async () => {
      await this.getBranches();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.pagination-area-edit-rule >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-edit-rule .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}
.pagination-area-edit-rule a {
  outline: none;
}
.dflex {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/bulletins/branch-bulletin/index.vue